import {
  Autocomplete,
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

/* DIALOG ZA EDIT USERA */

const UserEditModal = ({ open, user, roles, onClose, onSave }) => {
  const [selectedRole, setSelectedRole] = useState('');
  const [remark, setRemark] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    if (user) {
      const foundRole = roles.find((role) => role.id === String(user.role));
      if (foundRole) {
        setSelectedRole(foundRole.role_name);
      } else {
        setSelectedRole('');
      }
      setRemark(user.userRemark || '');
    }
  }, [user, roles]);

  const handleRoleChange = (event, newValue) => {
    const selectedRoleObject = roles.find(
      (role) => t(`roles.${role.role_name}`) === newValue
    );
    setSelectedRole(selectedRoleObject ? selectedRoleObject.role_name : '');
  };

  const roleOptions = roles.map((role) => ({
    ...role,
    translatedName: t(`roles.${role.role_name}`)
  }));

  const handleSave = () => {
    const selectedRoleObject = roles.find(
      (role) => role.role_name === selectedRole
    );
    onSave({ ...user, role: selectedRoleObject?.id, userRemark: remark });
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          backgroundColor: '#ffffff',
          borderRadius: '10px',
          padding: '20px',
          boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1)'
        }
      }}
    >
      <DialogTitle
        style={{
          fontSize: '1.4rem',
          fontWeight: '600',
          color: '#2979ff',
          textAlign: 'center',
          marginBottom: '15px'
        }}
      >
        {t('dialog.editSchool')}
      </DialogTitle>
      <DialogContent>
        <TextField
          label={t('dialog.name')}
          value={user?.userName || ''}
          fullWidth
          disabled
          sx={{
            marginBottom: '10px',
            backgroundColor: '#fff',
            borderRadius: '5px',
            padding: '8px',
            fontSize: '1rem',
            '& .MuiInputBase-input.Mui-disabled': {
              color: '#333'
            }
          }}
        />
        <Autocomplete
          options={roleOptions.map((role) => role.translatedName)}
          value={t(`roles.${selectedRole}`) || null}
          onChange={handleRoleChange}
          isOptionEqualToValue={(option, value) => option === value}
          fullWidth
          noOptionsText={t('pagination.noRowsLabel')}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t('dialog.role')}
              sx={{
                marginBottom: '10px',
                backgroundColor: '#fff',
                borderRadius: '5px',
                padding: '8px',
                fontSize: '1rem'
              }}
            />
          )}
        />
        <TextField
          label={t('dialog.remark')}
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          fullWidth
          multiline
          rows={3}
          sx={{
            backgroundColor: '#fff',
            borderRadius: '5px',
            padding: '8px',
            marginBottom: '15px',
            fontSize: '1rem'
          }}
        />
      </DialogContent>
      <DialogActions
        style={{
          justifyContent: 'space-between',
          padding: '0 10px 10px'
        }}
      >
        <Button
          onClick={onClose}
          style={{
            backgroundColor: '#e0e0e0',
            color: '#666666',
            fontWeight: '500',
            textTransform: 'none',
            fontSize: '1rem',
            padding: '8px 20px',
            borderRadius: '5px'
          }}
        >
          {t('dialog.cancel')}
        </Button>
        <Button
          onClick={handleSave}
          style={{
            backgroundColor: '#2979ff',
            color: '#fff',
            fontWeight: '600',
            textTransform: 'none',
            borderRadius: '5px',
            fontSize: '1rem',
            padding: '8px 20px'
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = '#1565c0')}
          onMouseOut={(e) => (e.target.style.backgroundColor = '#2979ff')}
        >
          {t('dialog.saveChanges')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default UserEditModal;
